import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container,
} from '@material-ui/core';

import ExtendedLogoPW from '../../assets/extended-logo-pw.svg';

import { optionStyles } from './style';


const Redirect: React.FC = () => {
  const classes = optionStyles();
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(() => {
      history.push("/mapa/sinistros");

    }, 4000);
    return () => clearTimeout(timer);
  }, [history]);

  return (
    <Container maxWidth="xl" className={classes.rootContainer}>

      <img src={ExtendedLogoPW} alt="Logo VIDA" width="250" className={classes.logo} />
    </Container>
  );
};

export default Redirect;
